import React from "react";
import { useAuth } from "../../lib/auth";
import { AdminHeader } from "../../components/admin/AdminUI";
import { User, Mail, Shield } from "lucide-react";

export default function Profile() {
  const { user } = useAuth();
  if (!user) return null;
  return (
    <div>
      <AdminHeader title="My Profile" subtitle="Manage your admin account" />
      <div className="card-elev p-8 max-w-xl">
        <div className="flex items-center gap-5">
          <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-brand-primary to-brand-secondary text-white flex items-center justify-center font-serif text-2xl font-bold">{user.name.charAt(0)}</div>
          <div>
            <div className="font-serif text-xl font-bold text-brand-text">{user.name}</div>
            <div className="text-sm text-brand-muted">{user.role}</div>
          </div>
        </div>
        <div className="mt-8 space-y-4 border-t border-brand-border pt-6">
          <div className="flex items-center gap-3"><Mail size={16} className="text-brand-muted" /> <span className="text-sm text-brand-text">{user.email}</span></div>
          <div className="flex items-center gap-3"><Shield size={16} className="text-brand-muted" /> <span className="text-sm text-brand-text uppercase tracking-wider">{user.role}</span></div>
          <div className="flex items-center gap-3"><User size={16} className="text-brand-muted" /> <span className="text-sm text-brand-text">Account ID: {user.id}</span></div>
        </div>
      </div>
    </div>
  );
}
